import React from "react";

import { Box, Collapse } from "@mui/material";
import { t } from "i18next";
import { StyledButton } from "../styled-button/styled-button";

type ActionsProps = {
  showBtns: boolean;
  resetSettings: any;
  updateSettings: any;
  canSubmit: any;
};

const FormActions = ({
  showBtns,
  resetSettings,
  updateSettings,
  canSubmit,
}: ActionsProps) => {
  return (
    <div data-testid="FormActions">
    <Box height="80px"></Box>
      <Box
        sx={{ position: "absolute", bottom: "30px", width: "100%", left: 0 }}
      >
        <Collapse in={showBtns} timeout={400}>
          <Box
            sx={{
              display: "flex",
              height: "80px",
              alignItems: "center",
              justifyContent: "center",
              background: "var(--kyocera-bg-grey)",
            }}
          >
            <StyledButton
              onClick={resetSettings}
              variant="contained"
              sx={{ bgcolor: `primary.darker`, color: `primary.light` }}
            >
              {t("common_cancel")}
            </StyledButton>
            <StyledButton
            type="submit"
              onClick={updateSettings}
              disabled={!canSubmit}
              style={{ textTransform: "none" }}
              variant="contained"
            > 
              {t("common_save")}
            </StyledButton>
          </Box>
        </Collapse>
      </Box>
    </div>
  );
};

export default FormActions;
